import request from '@/utils/request'

export function loadData(params){
    return request({
        url: '/product/shopee/list',
        method: 'get',
        params: params
    })
}

// 修改shopee产品信息1)业务定义：保存从各网站采集的产品信息，编辑产品。
export function updateShopee(pId) {
    return request({
        url: '/product/shopee',
        method: 'put',
        data: {'pId':pId,'pubStatus':'02'}
    })
}

// 修改shopee
export function updateShopeeRemark(form) {
    return request({
        url: '/product/shopee',
        method: 'put',
        data: form
    })
}

// 批量修改shopee产品信息1)业务定义：保存从各网站采集的产品信息，编辑产品。
export function batchUpdateByID(data) {
    return request({
        url: '/product/shopee/batchUpdateByID',
        method: 'put',
        data: data,
    })
}

//通过P_ID删除shopee产品的相关联表数据
export function singledeleteShopee(pId) {
    return request({
        url: '/product/shopee/singleDelete/'+pId,
        method: 'delete',
    })
}
//通过P_ID删除shopee产品的相关联表数据
export function batchdeleteShopee(pIds) {
    return request({
        url: '/product/shopee/batchDelete/'+pIds,
        method: 'delete',
    })
}

// 查询数据
export function getShopee(pId) {
    return request({
        url: '/product/shopee/' + pId,
        method: 'get'
    })
}


// 查询产品的编辑数据
export function getShopeeEdit(pId) {
    var params={
        pId:pId,
    }
    return request({
        url: '/product/shopee/getShopeeEditMsg',
        method: 'get',
        params:params,
    })
}

// bzxx上传图片
export function bzxxPicUpload(params) {
    return request({
        url: '/product/shopee/bzxxPicUpload',
        method: 'post',
        data:params,
    })
}

// bzxx颜色集合
export function getBzxxColor() {
    return request({
        url: '/product/shopee/getBzxxColor',
        method: 'get',
    })
}

// bzxxSIZE集合
export function getBzxxSize() {
    return request({
        url: '/product/shopee/getBzxxSize',
        method: 'get',
    })
}

// 查询商品数量
export function getCollectionBoxSize() {
    return request({
        url: '/product/shopee/getCollectionBoxSize',
        method: 'get',
    })
}

// 修改商品
export function saveEdit(data) {
    return request({
        url: '/product/shopee/saveEdit',
        method: 'post',
        data:data,
    })
}

// 创建产品
export function createdProduct(data) {
    return request({
        url: '/product/shopee/createdProduct',
        method: 'post',
        data:data,
    })
}

//批量定时发布
export function batchIntervalPublishItem(data){
    return request({
        url: '/product/shopee/release',
        method: 'post',
        params: data
    })
}

//取消定时发布
export function cancelTimed(data){
    return request({
        url: '/product/shopee/cancelTimed',
        method: 'post',
        params: data
    })
}

//查询在线产品的所有状态数量
export function getProductStateList(){
    return request({
        url: '/product/shopee/getProductStateList',
        method: 'get',

    })
}

//下架产品
export function lowerShelfProduct(pId){
    return request({
        url: '/product/shopee/lowerShelfProduct',
        method: 'put',
        params:{'pId':pId}
    })
}







